<template>
  <div>
    <section class="reservation-info" v-if="!isLoading">
      <div class="container">
        <div class="row">
          <div class="col-sm-7">
            <div class="header--reservation-detail">
              <div class="header--reservation-box">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-35 pz">
                    <li class="breadcrumb-item">
                      <router-link :to="'/job/provider'">
                        Provider Job
                      </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Details
                    </li>
                  </ol>
                </nav>
                <h4>Provider Jobs Details</h4>
                <div
                  :class="progressClassName"
                  :style="
                    isAirportTransfer && !isArrivedFlight && !isDepartureFlight
                      ? 'position: relative; bottom: 5px'
                      : ''
                  "
                ></div>
                <div class="table-legend">
                  <ul>
                    <li v-if="isAirportTransfer && isArrivedFlight">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-if="isAirportTransfer && isDepartureFlight">
                      <i class="ic-flight-departure-icon"></i>Airport Transfer
                    </li>
                    <li
                      style="display: flex"
                      v-else-if="
                        isAirportTransfer &&
                        !isArrivedFlight &&
                        !isDepartureFlight
                      "
                    >
                      <i class="ic-car-alt">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 1200 1200"
                        >
                          <path
                            fill="currentColor"
                            d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                          />
                        </svg>
                      </i>
                      Point to Point
                    </li>
                    <li v-else-if="!isAirportTransfer">
                      <i class="ic-time"></i>Hourly Booking
                    </li>
                  </ul>
                </div>
              </div>
              <div class="label-group" v-if="userType !== 'ProviderUser'">
                <div class="label">Payment Status</div>
                <div class="label-title">
                  <span
                    v-if="reservation.paymentStatus === 'Complete'"
                    class="--green35"
                    >Completed</span
                  >
                  <span v-else class="sts-danger">{{
                    humanize(reservation.paymentStatus)
                  }}</span>
                  <span
                    v-if="
                      reservation.paymentStatus === 'Unpaid' &&
                      reservation.paymentScheme === 'Offline'
                    "
                    >(Monthly invoice)</span
                  >
                </div>
              </div>
              <div
                class="label-group"
                v-if="reservation.paymentStatus === 'Complete'"
              >
                <div class="label">Payment Method</div>
                <div class="label-title">
                  <span>{{
                    humanize(reservation.paymentMethodDescription)
                  }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Status</div>
                <div class="label-title">
                  <span
                    :class="reservation.status === 'Cancelled' && 'sts-danger'"
                    >{{
                      reservation.status === "Quoted"
                        ? "Tentative"
                        : reservation.status
                    }}</span
                  >
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Code</div>
                <div class="label-title">
                  <span>{{ reservation.code }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Date</div>
                <div class="label-title">
                  <span>{{ reservation.reservationDate.stringFullDate }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Original Pick-up Date</div>
                <div class="label-title">
                  <span>{{
                    $helper.dateFormatted(
                      reservation.originalPickUpTime.dateTime
                    )
                  }}</span>
                  <span>{{
                    $helper.timeFormatted(
                      reservation.originalPickUpTime.dateTime
                    )
                  }}</span>
                  <span class="--grey50"
                    >({{ reservation.originalPickUpTime.timezone }})</span
                  >
                </div>
              </div>
              <div class="label-group" v-if="reservation.driver">
                <div class="label">Driver Name</div>
                <div class="label-title --green">
                  <span
                    >{{
                      reservation.driver.title
                        ? `${reservation.driver.title}.`
                        : ""
                    }}
                    {{ reservation.driver.fullName }}</span
                  >
                </div>
              </div>
              <div class="label-group" v-if="reservation.driver">
                <div class="label">Driver Phone</div>
                <div class="label-title">
                  <span>{{
                    reservation.driver.phoneCode &&
                    reservation.driver.phoneNumber
                      ? `(+${reservation.driver.phoneCode}) ${reservation.driver.phoneNumber}`
                      : "N/A"
                  }}</span>
                </div>
              </div>
              <div
                class="label-group"
                v-if="
                  reservation.driver &&
                  reservation.driver.alternatePhoneCode &&
                  reservation.driver.alternatePhoneNumber
                "
              >
                <div class="label">Alternate Driver Phone</div>
                <div class="label-title">
                  <span>{{
                    `(+${reservation.driver.alternatePhoneCode}) ${reservation.driver.alternatePhoneNumber}`
                  }}</span>
                </div>
              </div>
              <div class="label-group" v-if="reservation.driver">
                <div class="label">Driver Email</div>
                <div class="label-title --green">
                  <span>{{
                    reservation.driver.email ? reservation.driver.email : "-"
                  }}</span>
                </div>
              </div>
            </div>
            <div class="mb-25">
              <div class="row">
                <div class="col-sm-10">
                  <div class="dropandpickup">
                    <div class="col-sm-12 pz mb-15">
                      <div class="location-pick-up">
                        {{ reservation.pickUpLocation.name }}
                        <span class="address-location">{{
                          reservation.pickUpLocation.address
                        }}</span>
                      </div>
                      <div class="row mt-10">
                        <div class="col-sm-5 prz">
                          <div class="rent-date">
                            {{ reservation.pickUpDate.day }}
                            {{ reservation.pickUpDate.stringShortMonth }}
                          </div>
                        </div>
                        <div class="col-sm-7 text-right">
                          <div class="rent-time">
                            <i class="ic-time"></i>
                            {{ reservation.pickUpDate.stringHour }}:{{
                              reservation.pickUpDate.stringMinute
                            }}
                            <span class="utc-zone"
                              >({{ reservation.pickUpDate.offsetName }})</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 pz pt-10 divider-top-blue">
                      <div class="location-drop-off text-right">
                        {{ reservation.dropOffLocation.name }}
                        <span class="address-location">{{
                          reservation.dropOffLocation.address
                        }}</span>
                      </div>
                      <div class="row mt-10">
                        <div class="col-sm-5 prz">
                          <div class="rent-date">
                            {{ reservation.dropOffDate.day }}
                            {{ reservation.dropOffDate.stringShortMonth }}
                          </div>
                        </div>
                        <div class="col-sm-7 text-right">
                          <div class="rent-time">
                            <i class="ic-time"></i>
                            {{ reservation.dropOffDate.stringHour }}:{{
                              reservation.dropOffDate.stringMinute
                            }}
                            <span class="utc-zone"
                              >({{ reservation.dropOffDate.offsetName }})</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2 plz text-center">
                  <div class="map-capture"></div>
                  <div class="btn btn-flat" @click.prevent="openMapModal()">
                    View Map
                  </div>
                </div>
              </div>
              <!-- /.row -->
            </div>

            <div class="body--reservation-detail">
              <div class="row">
                <div
                  :class="
                    !sameBookerAndPassenger
                      ? 'col-sm-6 divider-right'
                      : 'col-sm-6'
                  "
                >
                  <i class="ic-businessmen pull-left mr-10 --green"></i>
                  <h4 class="--green">Passenger Details</h4>
                  <div class="label-group" v-if="userType !== 'ProviderUser'">
                    <div class="label">Company</div>
                    <div class="label-title">
                      {{
                        reservation.customers[0].companyName
                          ? reservation.customers[0].companyName
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ reservation.customers[0].title }}.
                      {{ reservation.customers[0].fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      {{
                        reservation.customers[0].phoneCode &&
                        reservation.customers[0].phoneNumber
                          ? `(+${reservation.customers[0].phoneCode}) ${reservation.customers[0].phoneNumber}`
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <div class="label-group" v-if="userType !== 'ProviderUser'">
                    <div class="label">Email</div>
                    <div class="label-title">
                      {{
                        reservation.customers[0].email
                          ? reservation.customers[0].email
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <template>
                    <div
                      class="label-group"
                      v-if="reservation.numberOfPassengers"
                    >
                      <div class="label">Number of Passengers</div>
                      <div class="label-title">
                        {{ reservation.numberOfPassengers }}
                      </div>
                    </div>
                    <div
                      class="label-group"
                      v-if="reservation.numberOfSmallLuggages"
                    >
                      <div class="label">Number of Small Luggages</div>
                      <div class="label-title">
                        {{ reservation.numberOfSmallLuggages }}
                      </div>
                    </div>
                    <div
                      class="label-group"
                      v-if="reservation.numberOfBigLuggages"
                    >
                      <div class="label">Number of Big Luggages</div>
                      <div class="label-title">
                        {{ reservation.numberOfBigLuggages }}
                      </div>
                    </div>
                  </template>
                  <div
                    class="label-group"
                    v-if="
                      reservation.customers[0].employeeId &&
                      userType === 'TenantUser'
                    "
                  >
                    <div class="label">Employee ID</div>
                    <div class="label-title">
                      {{ reservation.customers[0].employeeId }}
                    </div>
                  </div>
                  <div
                    class="label-group"
                    v-if="
                      reservation.customers[0].costCenter &&
                      userType === 'TenantUser'
                    "
                  >
                    <div class="label">Cost Centre</div>
                    <div class="label-title">
                      {{ reservation.customers[0].costCenter }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Signage</div>
                    <div class="label-title" style="position: relative">
                      <label
                        for="edit-signage"
                        class="btn-edit-signage"
                        v-if="userType !== 'ProviderUser'"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5c0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5l5 5h-3z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <span>Upload New</span>
                      </label>
                      <label
                        for="download-signage"
                        class="btn-download-signage"
                        :style="userType === 'ProviderUser' && 'top: 5px;'"
                        @click="downloadSignage()"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5c0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5l-5-5h3V9h4v4h3z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <span>Download</span>
                      </label>
                      <label
                        for="delete-signage"
                        class="btn-delete-signage"
                        v-if="
                          userType !== 'ProviderUser' &&
                          reservation.signage &&
                          reservation.signage.fileUrl
                        "
                        @click="openDeleteModal()"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M6 21h12V7H6v14zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <span>Delete</span>
                      </label>
                      <template
                        v-if="
                          reservation.signage && reservation.signage.fileUrl
                        "
                      >
                        <img
                          :src="reservation.signage.fileUrl"
                          alt="signage-image"
                          class="signage-image-preview"
                          v-if="!isPDFFile"
                        />
                        <PdfViewer
                          :pdf-url="reservation.signage.fileUrl"
                          urlFrom="detail"
                          v-else
                        />
                      </template>
                      <div class="signage-box" v-else>
                        {{ reservation.customers[0].title }}.
                        {{ reservation.customers[0].fullName }}
                      </div>
                      <input
                        type="file"
                        class="edit-signage"
                        id="edit-signage"
                        accept=".png, .jpeg, .jpg, .pdf"
                        @change="editSignage($event.target.files)"
                      />
                    </div>
                  </div>
                  <!-- <div class="mt-30">
                    <button class="btn btn-secondary">Email Job Status</button>
                    <button class="btn btn-secondary">SMS Job Status</button>
                  </div> -->
                </div>
                <div
                  :class="
                    sameBookerAndPassenger
                      ? 'col-sm-6 text-right divider-left'
                      : 'col-sm-6 text-right'
                  "
                  v-if="!sameBookerAndPassenger && userType !== 'ProviderUser'"
                >
                  <h4>Booker</h4>
                  <div class="label-group" v-if="userType !== 'ProviderUser'">
                    <div class="label">Company</div>
                    <div class="label-title">
                      {{
                        reservation.booker.companyName
                          ? reservation.booker.companyName
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ reservation.booker.title }}.
                      {{ reservation.booker.fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      {{
                        reservation.booker.phoneCode &&
                        reservation.booker.phoneNumber
                          ? `(+${reservation.booker.phoneCode}) ${reservation.booker.phoneNumber}`
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Email</div>
                    <div class="label-title">
                      {{
                        reservation.booker.email
                          ? reservation.booker.email
                          : "N/A"
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="passenger-flight-info">
              <div
                v-if="
                  reservation.flightInfo &&
                  reservation.flightInfo.carrierName &&
                  reservation.flightInfo.carrierCode &&
                  reservation.flightInfo.flightNumber
                "
              >
                <h4>Passenger Flight Info</h4>
                <div class="label-group">
                  <div class="label flight-info-label">Airline</div>
                  <div class="label-title">
                    <span class="--green passenger__flight">{{
                      reservation.flightInfo.carrierName
                    }}</span
                    ><span style="margin-left: 5px"
                      >({{ reservation.flightInfo.carrierCode }}-{{
                        reservation.flightInfo.flightNumber
                      }})</span
                    >
                  </div>
                </div>
                <div
                  class="label-group"
                  v-if="
                    reservation.flightEstimatedArrivalTimes &&
                    userType !== 'CorporateUser' &&
                    reservation.pickUpLocation.isAirport
                  "
                >
                  <div class="label flight-info-label">Flight ETA</div>
                  <div class="label-title">
                    <span>{{
                      reservation.flightEstimatedArrivalTimes.dateTime
                        | momentTime
                    }}</span
                    ><span class="--grey45" style="margin-left: 5px"
                      >({{
                        reservation.flightEstimatedArrivalTimes.timezone
                      }})</span
                    >
                  </div>
                </div>
                <div
                  class="label-group"
                  v-if="
                    reservation.flightConfirmedTimes &&
                    userType !== 'CorporateUser' &&
                    reservation.pickUpLocation.isAirport
                  "
                >
                  <div class="label flight-info-label">
                    Flight Confirmed Time
                  </div>
                  <div class="label-title">
                    <span>{{
                      reservation.flightConfirmedTimes.dateTime | momentTime
                    }}</span
                    ><span class="--grey45" style="margin-left: 5px"
                      >({{ reservation.flightConfirmedTimes.timezone }})</span
                    >
                  </div>
                </div>
                <div
                  class="label-group"
                  v-if="
                    reservation.driverStandbyTime &&
                    userType !== 'CorporateUser' &&
                    reservation.pickUpLocation.isAirport
                  "
                >
                  <div class="label flight-info-label">Driver Standby Time</div>
                  <div class="label-title">
                    <span>{{
                      reservation.driverStandbyTime.dateTime | momentTime
                    }}</span
                    ><span class="--grey45" style="margin-left: 5px"
                      >({{ reservation.driverStandbyTime.timezone }})</span
                    >
                  </div>
                </div>
              </div>

              <div v-if="reservation.noteToDriver">
                <h4>Notes to Driver</h4>
                <div class="passenger-notes">
                  {{ reservation.noteToDriver }}
                </div>
              </div>

              <div
                v-if="
                  isAllowViewCustomerNotes &&
                  (reservation.passengerNameRecord ||
                    reservation.project ||
                    reservation.additionalRequest ||
                    reservation.booker.employeeId ||
                    reservation.booker.costCenter)
                "
                style="border-top: 0.5px solid #999"
              >
                <h4 style="margin-top: 20px">Customer Information</h4>
                <div class="body--reservation-detail additional-table">
                  <div class="row">
                    <div class="col-sm-12">
                      <div
                        class="label-group"
                        v-if="reservation.passengerNameRecord"
                      >
                        <div class="label">PNR/Client Booking No.</div>
                        <div class="label-title">
                          {{ reservation.passengerNameRecord }}
                        </div>
                      </div>
                      <div class="label-group" v-if="reservation.project">
                        <div class="label">Project Name</div>
                        <div class="label-title">
                          {{ reservation.project }}
                        </div>
                      </div>
                      <div
                        class="label-group"
                        v-if="
                          reservation.booker.employeeId &&
                          userType === 'TenantUser'
                        "
                      >
                        <div class="label">Employee ID</div>
                        <div class="label-title">
                          {{ reservation.booker.employeeId }}
                        </div>
                      </div>
                      <div
                        class="label-group"
                        v-if="
                          reservation.booker.costCenter &&
                          userType === 'TenantUser'
                        "
                      >
                        <div class="label">Cost Centre</div>
                        <div class="label-title">
                          {{ reservation.booker.costCenter }}
                        </div>
                      </div>
                      <div
                        class="label-group"
                        v-if="reservation.additionalRequest"
                      >
                        <div class="label">Additional Request</div>
                        <div class="label-title">
                          {{ reservation.additionalRequest }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style="border-top: 0.5px solid #999"
                v-if="isAllowViewAdminNotes && reservation.adminNotes"
              >
                <h4 style="margin-top: 20px">Admin Notes</h4>
                <div class="admin-notes">
                  {{ reservation.adminNotes }}
                </div>
              </div>

              <div
                class="stops-section"
                v-if="reservation.stops && reservation.stops.length"
              >
                <h4 style="margin-top: 20px">Stops</h4>
                <!-- Card -->
                <div
                  class="stops-card"
                  v-for="(stop, iStop) in reservation.stops"
                  :key="iStop"
                >
                  <div class="stops-content">
                    <div
                      class="stops-address"
                      :class="{ 'mt-10': stop.waitTime > 0 }"
                    >
                      <i class="ic-marker-point"></i>
                      {{ stop.location.name }}
                    </div>
                  </div>

                  <div class="right" v-if="stop.waitTime > 0">
                    <div class="stops-badge">
                      <i class="ic-time" style="font-size: 14px"></i>
                      {{ Number(stop.waitTime) }} mins wait
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-addons mt-20">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading text-center">
                    <h4 class="panel-title">
                      <a
                        class="--green"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        @click="handleCollapse()"
                      >
                        <i class="ic-History mr-5"></i>Reservation History
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse1"
                    class="panel-collapse collapse"
                    :class="collapseHistory && 'in'"
                  >
                    <div class="panel-body">
                      <div class="trip-info">
                        <div
                          v-for="(history, index) in reservation.histories"
                          :key="index"
                        >
                          <div class="col-sm-3">
                            <div class="time__depart">
                              <div class="time_Is">
                                {{ history.createdDate.stringHour }}:{{
                                  history.createdDate.stringMinute
                                }}:{{
                                  `${
                                    history.createdDate.second.toString()
                                      .length > 1
                                      ? ""
                                      : "0"
                                  }${history.createdDate.second}`
                                }}
                              </div>
                              <div class="date_Is">
                                ({{ history.createdDate.offsetName }})
                              </div>
                              <div class="date_Is">
                                {{ history.createdDate.stringDate }}
                                {{ history.createdDate.stringShortMonth }}
                                {{ history.createdDate.year }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-9">
                            <div
                              :class="[
                                index === reservation.histories.length - 1
                                  ? 'end-time-stamp'
                                  : 'time-stamp',
                                history.event.toLowerCase().includes('dropped')
                                  ? 'dropped'
                                  : '',
                              ]"
                            >
                              <div class="stamp-status --green">
                                {{ humanize(history.eventText) }}
                              </div>
                              <div
                                class="stamp-desc"
                                v-html="getEventDescription(history)"
                              />
                              <div
                                v-if="showAmendLog(history)"
                                class="stamp-desc"
                              >
                                <div
                                  v-if="
                                    history.amendLog.contexts.includes(
                                      'booker' && history.amendLog.booker
                                    ) && showBookerOnHistory(history.amendLog)
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">Booker:</p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.booker.previous.title} ${history.amendLog.booker.previous.fullName}` !==
                                        `${history.amendLog.booker.new.title} ${history.amendLog.booker.new.fullName}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Name
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.booker.previous.title
                                        }}
                                        {{
                                          history.amendLog.booker.previous
                                            .fullName
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.booker.previous.phoneCode} ${history.amendLog.booker.previous.phoneNumber}` !==
                                        `${history.amendLog.booker.new.phoneCode} ${history.amendLog.booker.new.phoneNumber}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Phone
                                      </div>
                                      <div class="history-value history-font">
                                        (+{{
                                          history.amendLog.booker.previous
                                            .phoneCode
                                        }})
                                        {{
                                          history.amendLog.booker.previous
                                            .phoneNumber
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.booker.previous
                                          .email !==
                                        history.amendLog.booker.new.email
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Email
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.booker.previous.email
                                        }}
                                      </div>
                                    </div>
                                    <p class="h-color-label mb-0">To:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.booker.previous.title} ${history.amendLog.booker.previous.fullName}` !==
                                        `${history.amendLog.booker.new.title} ${history.amendLog.booker.new.fullName}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Name
                                      </div>
                                      <div class="history-value history-font">
                                        {{ history.amendLog.booker.new.title }}
                                        {{
                                          history.amendLog.booker.new.fullName
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.booker.previous.phoneCode} ${history.amendLog.booker.previous.phoneNumber}` !==
                                        `${history.amendLog.booker.new.phoneCode} ${history.amendLog.booker.new.phoneNumber}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Phone
                                      </div>
                                      <div class="history-value history-font">
                                        (+{{
                                          history.amendLog.booker.new.phoneCode
                                        }})
                                        {{
                                          history.amendLog.booker.new
                                            .phoneNumber
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.booker.previous
                                          .email !==
                                        history.amendLog.booker.new.email
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Email
                                      </div>
                                      <div class="history-value history-font">
                                        {{ history.amendLog.booker.new.email }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  v-if="
                                    history.amendLog.contexts.includes(
                                      'passenger'
                                    ) &&
                                    history.amendLog.passenger &&
                                    showPassengerDetailOnHistory(
                                      history.amendLog
                                    )
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">
                                    Passenger Details:
                                  </p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passenger.previous.title} ${history.amendLog.passenger.previous.fullName}` !==
                                        `${history.amendLog.passenger.new.title} ${history.amendLog.passenger.new.fullName}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Name
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passenger.previous
                                            .title
                                        }}
                                        {{
                                          history.amendLog.passenger.previous
                                            .fullName
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passenger.previous.phoneCode} ${history.amendLog.passenger.previous.phoneNumber}` !==
                                        `${history.amendLog.passenger.new.phoneCode} ${history.amendLog.passenger.new.phoneNumber}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Phone
                                      </div>
                                      <div class="history-value history-font">
                                        (+{{
                                          history.amendLog.passenger.previous
                                            .phoneCode
                                        }})
                                        {{
                                          history.amendLog.passenger.previous
                                            .phoneNumber
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.passenger.previous
                                          .email !==
                                        history.amendLog.passenger.new.email
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Email
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passenger.previous
                                            .email
                                        }}
                                      </div>
                                    </div>
                                    <p class="h-color-label mb-0">To:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passenger.previous.title} ${history.amendLog.passenger.previous.fullName}` !==
                                        `${history.amendLog.passenger.new.title} ${history.amendLog.passenger.new.fullName}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Name
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passenger.new.title
                                        }}
                                        {{
                                          history.amendLog.passenger.new
                                            .fullName
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.passenger.previous
                                          .phoneCode !==
                                        history.amendLog.passenger.new.phoneCode
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Phone
                                      </div>
                                      <div class="history-value history-font">
                                        (+{{
                                          history.amendLog.passenger.new
                                            .phoneCode
                                        }})
                                        {{
                                          history.amendLog.passenger.new
                                            .phoneNumber
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.passenger.previous
                                          .email !==
                                        history.amendLog.passenger.new.email
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Email
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passenger.new.email
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  v-if="
                                    history.amendLog.contexts.includes(
                                      'flight_details'
                                    )
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">
                                    Passenger Flight Info:
                                  </p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <div class="d-flex">
                                      <div>
                                        {{
                                          history.amendLog.flightDetail.previous
                                            .carrierName
                                        }}
                                        (
                                        {{
                                          history.amendLog.flightDetail.previous
                                            .carrierCode
                                        }}-{{
                                          history.amendLog.flightDetail.previous
                                            .flightNumber
                                        }}
                                        )
                                      </div>
                                    </div>
                                    <p class="h-color-label mb-0">To:</p>
                                    <div class="d-flex">
                                      <div>
                                        {{
                                          history.amendLog.flightDetail.new
                                            .carrierName
                                        }}
                                        (
                                        {{
                                          history.amendLog.flightDetail.new
                                            .carrierCode
                                        }}-{{
                                          history.amendLog.flightDetail.new
                                            .flightNumber
                                        }}
                                        )
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  v-if="
                                    history.amendLog.contexts.includes('notes')
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">Notes:</p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <div
                                      class="history-font"
                                      v-if="
                                        history.amendLog.notes.previous.length
                                      "
                                    >
                                      {{
                                        history.amendLog.notes.previous.join()
                                      }}
                                    </div>
                                    <div v-else>( - )</div>
                                    <p class="h-color-label mb-0">To:</p>
                                    <div
                                      class="history-font"
                                      v-if="history.amendLog.notes.new.length"
                                    >
                                      {{ history.amendLog.notes.new.join() }}
                                    </div>
                                    <div v-else>( - )</div>
                                  </div>
                                </div>

                                <div
                                  v-if="
                                    history.amendLog.contexts.includes(
                                      'schedules'
                                    ) && showScheduleOnHistory(history.amendLog)
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">Schedules:</p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.schedules.previous
                                          .pickUp !==
                                        history.amendLog.schedules.new.pickUp
                                      "
                                    >
                                      <div
                                        class="history-label history-font"
                                        style="width: 100px"
                                      >
                                        Pick-up Date
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          $helper.formatDateTime(
                                            new Date(
                                              history.amendLog.schedules.previous.pickUp
                                            )
                                          )
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.schedules.previous
                                          .dropOff !==
                                        history.amendLog.schedules.new.dropOff
                                      "
                                    >
                                      <div
                                        class="history-label history-font"
                                        style="width: 100px"
                                      >
                                        Drop-off Date
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          $helper.formatDateTime(
                                            new Date(
                                              history.amendLog.schedules.previous.dropOff
                                            )
                                          )
                                        }}
                                      </div>
                                    </div>
                                    <p class="h-color-label mb-0">To:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.schedules.previous
                                          .pickUp !==
                                        history.amendLog.schedules.new.pickUp
                                      "
                                    >
                                      <div
                                        class="history-label history-font"
                                        style="width: 100px"
                                      >
                                        Pick-up Date
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          $helper.formatDateTime(
                                            new Date(
                                              history.amendLog.schedules.new.pickUp
                                            )
                                          )
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.schedules.previous
                                          .dropOff !==
                                        history.amendLog.schedules.new.dropOff
                                      "
                                    >
                                      <div
                                        class="history-label history-font"
                                        style="width: 100px"
                                      >
                                        Drop-off Date
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          $helper.formatDateTime(
                                            new Date(
                                              history.amendLog.schedules.new.dropOff
                                            )
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  v-if="
                                    history.amendLog.contexts.includes(
                                      'locations'
                                    ) &&
                                    showDestinationOnHistory(history.amendLog)
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">Destinations:</p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.locations.previous
                                          .pickUpName !==
                                        history.amendLog.locations.new
                                          .pickUpName
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Pick-up
                                      </div>
                                      <div
                                        class="history-value history-font"
                                      ></div>
                                      <span class="history-font">{{
                                        history.amendLog.locations.previous
                                          .pickUpName
                                      }}</span>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.locations.previous
                                          .dropOffName !==
                                        history.amendLog.locations.new
                                          .dropOffName
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Drop-off
                                      </div>
                                      <div
                                        class="history-value history-font"
                                      ></div>
                                      <span class="history-font">{{
                                        history.amendLog.locations.previous
                                          .dropOffName
                                      }}</span>
                                    </div>
                                    <p class="h-color-label mb-0">To:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.locations.previous
                                          .pickUpName !==
                                        history.amendLog.locations.new
                                          .pickUpName
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Pick-up
                                      </div>
                                      <div
                                        class="history-value history-font"
                                      ></div>
                                      <span class="history-font">{{
                                        history.amendLog.locations.new
                                          .pickUpName
                                      }}</span>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        history.amendLog.locations.previous
                                          .dropOffName !==
                                        history.amendLog.locations.new
                                          .dropOffName
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Drop-off
                                      </div>
                                      <div
                                        class="history-value history-font"
                                      ></div>
                                      <span class="history-font">{{
                                        history.amendLog.locations.new
                                          .dropOffName
                                      }}</span>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  v-if="
                                    history.amendLog.contexts.includes(
                                      'vehicle_class'
                                    )
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">Vehicle Class:</p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <div class="history-font">
                                      {{
                                        history.amendLog.vehicleClass.previous
                                      }}
                                    </div>
                                    <p class="h-color-label mb-0">To:</p>
                                    <div class="history-font">
                                      {{ history.amendLog.vehicleClass.new }}
                                    </div>
                                  </div>
                                </div>

                                <div
                                  v-if="
                                    history.amendLog.contexts.includes(
                                      'ancillaries'
                                    )
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">Ancillary:</p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <ul
                                      class="table-list-history"
                                      v-if="
                                        history.amendLog.ancillaries.previous
                                          .length
                                      "
                                    >
                                      <li
                                        v-for="(ancilPrev, index) in history
                                          .amendLog.ancillaries.previous"
                                        :key="index"
                                      >
                                        {{ ancilPrev.name
                                        }}<span>x{{ ancilPrev.qty }}</span
                                        ><span class="value"
                                          >{{
                                            $currencyFormat(
                                              reservation.currencyCode,
                                              ancilPrev.rate
                                            )
                                          }}
                                        </span>
                                      </li>
                                    </ul>
                                    <ul class="table-list-history" v-else>
                                      <li>( - )</li>
                                    </ul>
                                    <p class="h-color-label mb-0">To:</p>
                                    <ul
                                      class="table-list-history"
                                      v-if="
                                        history.amendLog.ancillaries.new.length
                                      "
                                    >
                                      <li
                                        v-for="(ancilPrev, index) in history
                                          .amendLog.ancillaries.new"
                                        :key="index"
                                      >
                                        {{ ancilPrev.name
                                        }}<span>x{{ ancilPrev.qty }}</span
                                        ><span class="value">{{
                                          $currencyFormat(
                                            reservation.currencyCode,
                                            ancilPrev.rate
                                          )
                                        }}</span>
                                      </li>
                                    </ul>
                                    <ul class="table-list-history" v-else>
                                      <li>( - )</li>
                                    </ul>
                                  </div>
                                </div>

                                <div
                                  v-if="
                                    history.amendLog.contexts.includes(
                                      'passenger_info'
                                    )
                                  "
                                  class="mb-5"
                                >
                                  <p class="rent-date mb-0">Passenger Info:</p>
                                  <div class="pl-10">
                                    <p class="h-color-label mb-0">From:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passengerInfo.previous.numberOfPassengers}` !==
                                        `${history.amendLog.passengerInfo.new.numberOfPassengers}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Number of Passengers:
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passengerInfo
                                            .previous.numberOfPassengers
                                            ? history.amendLog.passengerInfo
                                                .previous.numberOfPassengers
                                            : "-"
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passengerInfo.previous.numberOfBigLuggages}` !==
                                        `${history.amendLog.passengerInfo.new.numberOfBigLuggages}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Number of Big Luggages:
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passengerInfo
                                            .previous.numberOfBigLuggages
                                            ? history.amendLog.passengerInfo
                                                .previous.numberOfBigLuggages
                                            : "-"
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passengerInfo.previous.numberOfSmallLuggages}` !==
                                        `${history.amendLog.passengerInfo.new.numberOfSmallLuggages}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Number of Small Luggages:
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passengerInfo
                                            .previous.numberOfSmallLuggages
                                            ? history.amendLog.passengerInfo
                                                .previous.numberOfSmallLuggages
                                            : "-"
                                        }}
                                      </div>
                                    </div>
                                    <p class="h-color-label mb-0">To:</p>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passengerInfo.previous.numberOfPassengers}` !==
                                        `${history.amendLog.passengerInfo.new.numberOfPassengers}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Number of Passengers:
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passengerInfo.new
                                            .numberOfPassengers
                                            ? history.amendLog.passengerInfo.new
                                                .numberOfPassengers
                                            : " -"
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passengerInfo.previous.numberOfBigLuggages}` !==
                                        `${history.amendLog.passengerInfo.new.numberOfBigLuggages}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Number of Big Luggages:
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passengerInfo.new
                                            .numberOfBigLuggages
                                            ? history.amendLog.passengerInfo.new
                                                .numberOfBigLuggages
                                            : "-"
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="history-group"
                                      v-if="
                                        `${history.amendLog.passengerInfo.previous.numberOfSmallLuggages}` !==
                                        `${history.amendLog.passengerInfo.new.numberOfSmallLuggages}`
                                      "
                                    >
                                      <div class="history-label history-font">
                                        Number of Small Luggages:
                                      </div>
                                      <div class="history-value history-font">
                                        {{
                                          history.amendLog.passengerInfo.new
                                            .numberOfSmallLuggages
                                            ? history.amendLog.passengerInfo.new
                                                .numberOfSmallLuggages
                                            : "-"
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <template
                                v-if="
                                  history.attachments &&
                                  history.attachments.length
                                "
                              >
                                <div v-if="history.attachments.length">
                                  <button
                                    class="btn btn-default"
                                    type="button"
                                    @click="getAttachmentImage(history)"
                                  >
                                    <span>Show</span>
                                  </button>
                                </div>
                              </template>

                              <template v-else>
                                <div v-if="isButtonShow(history.description)">
                                  <button
                                    class="btn btn-default"
                                    type="button"
                                    @click="getImage(history)"
                                  >
                                    <span>Show</span>
                                  </button>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.booking History -->
          </div>

          <div class="col-sm-5">
            <div
              class="price-detail-header"
              v-if="
                reservation.fareComponents &&
                reservation.fareComponents.length > 0
              "
            >
              <div class="grand-total">
                <table class="table table-amount">
                  <thead>
                    <tr>
                      <th class="text-left --green v-align-top">
                        Total Amount
                      </th>
                      <th class="text-right">
                        <div class="flex-column" style="line-height: 15px">
                          <strong>
                            {{ reservation.currencyCode }}
                            {{
                              $currencyFormat(
                                reservation.currencyCode,
                                reservation.grandTotal
                              )
                            }}
                          </strong>
                          <strong
                            v-if="
                              isDifferentCurrency &&
                              reservation.equivalentCurrencyCode
                            "
                          >
                            <span class="text-10">
                              {{ reservation.equivalentCurrencyCode }}
                              {{
                                $currencyFormat(
                                  reservation.equivalentCurrencyCode,
                                  reservation.equivalentGrandTotal
                                )
                              }}
                            </span>
                          </strong>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left v-align-top">Base</td>
                      <td class="text-right v-align-top">
                        <div class="flex-column" style="line-height: 15px">
                          <strong
                            >{{ reservation.currencyCode }}
                            {{
                              $currencyFormat(
                                reservation.currencyCode,
                                reservation.baseFare
                              )
                            }}</strong
                          >
                          <template
                            v-if="
                              isDifferentCurrency &&
                              reservation.equivalentCurrencyCode
                            "
                          >
                            <span class="text-10"
                              >{{ reservation.equivalentCurrencyCode }}
                              {{
                                $currencyFormat(
                                  reservation.equivalentCurrencyCode,
                                  reservation.equivalentBaseFare
                                )
                              }}</span
                            >
                          </template>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="reservation.surchargeTotal > 0">
                      <td class="text-left v-align-top">Surcharge</td>
                      <td class="text-right v-align-top">
                        <div class="flex-column" style="line-height: 15px">
                          <strong
                            >{{ reservation.currencyCode }}
                            {{
                              $currencyFormat(
                                reservation.currencyCode,
                                reservation.surchargeTotal
                              )
                            }}</strong
                          >
                          <template
                            v-if="
                              isDifferentCurrency &&
                              reservation.equivalentCurrencyCode
                            "
                          >
                            <span class="text-10"
                              >{{ reservation.equivalentCurrencyCode }}
                              {{
                                $currencyFormat(
                                  reservation.equivalentCurrencyCode,
                                  reservation.equivalentSurchargeTotal
                                )
                              }}</span
                            >
                          </template>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="surcharges && surcharges.length > 0">
                      <td colspan="2" class="v-align-top">
                        <ul class="table-list">
                          <template v-for="(surcharge, index) in surcharges">
                            <li
                              :key="index"
                              v-if="surcharge.rate > 0"
                              class="v-align-top"
                              style="line-height: 30px"
                            >
                              {{ surcharge.name
                              }}<span
                                class="v-align-top"
                                v-if="!surcharge.isPreBooking"
                                >{{
                                  surcharge.name === "Arrival Waiting Time" ||
                                  surcharge.name === "Waiting Time"
                                    ? ""
                                    : "x"
                                }}{{ surcharge.quantity
                                }}{{
                                  surcharge.name === "Arrival Waiting Time" ||
                                  surcharge.name === "Waiting Time"
                                    ? "min"
                                    : ""
                                }}</span
                              >
                              <span
                                class="value flex-column"
                                style="line-height: 20px"
                              >
                                <span class="text-right --grey25">
                                  {{ reservation.currencyCode }}
                                  {{
                                    $currencyFormat(
                                      reservation.currencyCode,
                                      surcharge.rate
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    isDifferentCurrency &&
                                    reservation.equivalentCurrencyCode
                                  "
                                  class="text-right text-10 --grey25"
                                >
                                  {{ reservation.equivalentCurrencyCode }}
                                  {{
                                    $currencyFormat(
                                      reservation.equivalentCurrencyCode,
                                      surcharge.equivalentRate
                                    )
                                  }}
                                </span>
                              </span>
                            </li>
                          </template>
                        </ul>
                      </td>
                    </tr>
                    <tr v-if="reservation.ancillaryTotal > 0">
                      <td class="text-left v-align-top">Ancillary</td>
                      <td class="text-right v-align-top">
                        <div class="flex-column" style="line-height: 15px">
                          <strong
                            >{{ reservation.currencyCode }}
                            {{
                              $currencyFormat(
                                reservation.currencyCode,
                                reservation.ancillaryTotal
                              )
                            }}</strong
                          >
                          <template
                            v-if="
                              isDifferentCurrency &&
                              reservation.equivalentCurrencyCode
                            "
                          >
                            <span class="text-10"
                              >{{ reservation.equivalentCurrencyCode }}
                              {{
                                $currencyFormat(
                                  reservation.equivalentCurrencyCode,
                                  reservation.equivalentAncillaryTotal
                                )
                              }}</span
                            >
                          </template>
                        </div>
                      </td>
                    </tr>
                    <tr
                      v-if="ancillaries && ancillaries.length > 0"
                      id="ancillary-list-item"
                    >
                      <td colspan="2">
                        <ul class="table-list ancillary-list">
                          <li
                            v-for="(ancillary, index) in ancillaries"
                            :key="index"
                            class="ancillary-item"
                          >
                            <div class="ancillary-info">
                              <span class="ancillary-name">
                                {{ ancillary.name }}
                              </span>

                              <span class="ancillary-quantity">
                                x{{ ancillary.quantity }}
                              </span>
                            </div>

                            <span class="value ancillary-price">
                              <span class="--grey25">
                                {{ reservation.currencyCode }}
                                {{
                                  $currencyFormat(
                                    reservation.currencyCode,
                                    ancillary.rate
                                  )
                                }}
                              </span>

                              <span
                                class="ancillary-equivalent-price text-10 text-right --grey45"
                                v-if="
                                  isDifferentCurrency &&
                                  reservation.equivalentCurrencyCode
                                "
                              >
                                {{ ancillary.equivalentCurrencyCode }}
                                {{
                                  $currencyFormat(
                                    ancillary.equivalentCurrencyCode,
                                    ancillary.equivalentRate
                                  )
                                }}
                              </span>
                            </span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr v-if="isHaveExtra">
                      <td class="text-left v-align-top">Post-Booking Extras</td>
                      <td class="text-right v-align-top">
                        <span
                          class="value flex-column"
                          v-if="totalExtraService > 0"
                        >
                          <strong
                            >{{ reservation.currencyCode }}
                            {{
                              $currencyFormat(
                                reservation.currencyCode,
                                totalExtraService
                              )
                            }}</strong
                          >
                          <template
                            v-if="
                              isDifferentCurrency &&
                              reservation.equivalentCurrencyCode
                            "
                          >
                            <span class="text-10">
                              {{ reservation.equivalentCurrencyCode }}
                              {{
                                $currencyFormat(
                                  reservation.equivalentCurrencyCode,
                                  totalEquivalentExtraService
                                )
                              }}
                            </span>
                          </template>
                        </span>
                      </td>
                    </tr>
                    <tr v-if="isHaveExtra">
                      <td colspan="2" class="v-align-top">
                        <ul class="table-list">
                          <template v-for="(service, index) in postBooking">
                            <li
                              :key="index"
                              v-if="service.quantity > 0 && service.rate > 0"
                              style="min-height: 30px"
                            >
                              {{ service.name }}
                              <span>x{{ service.quantity }}</span>
                              <span
                                class="value text-right flex-column v-align-top"
                                v-if="service.rate > 0"
                              >
                                <span class="text-right --grey25"
                                  >{{ reservation.currencyCode }}
                                  {{
                                    $currencyFormat(
                                      reservation.currencyCode,
                                      service.rate
                                    )
                                  }}</span
                                >
                                <span
                                  v-if="
                                    isDifferentCurrency &&
                                    reservation.equivalentCurrencyCode
                                  "
                                  class="text-right text-10 --grey25"
                                >
                                  {{ reservation.equivalentCurrencyCode }}
                                  {{
                                    $currencyFormat(
                                      reservation.equivalentCurrencyCode,
                                      service.equivalentRate
                                    )
                                  }}
                                </span>
                              </span>
                            </li>
                          </template>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="price-detail-header"
              v-if="
                reservation.sellingAncillaries &&
                reservation.sellingAncillaries.length > 0
              "
            >
              <div class="grand-total">
                <h4 class="strong mt-20 pb-20 divider-bottom">
                  <div class="info-icon --pentung-mark"></div>
                  Requested Ancillaries
                </h4>
                <table class="table table-amount">
                  <tbody>
                    <tr>
                      <td colspan="2" class="ptz">
                        <ul class="table-list">
                          <li
                            v-for="(
                              ancillary, index
                            ) in reservation.sellingAncillaries"
                            :key="index"
                          >
                            {{ ancillary.name
                            }}<span>x{{ ancillary.quantity }}</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="reservation-summary--small"
              v-if="reservation.vehicle || reservation.provider"
            >
              <div class="brand-box" v-if="reservation.vehicle">
                <div class="type-car" v-if="reservation.vehicle.className">
                  {{ reservation.vehicle.className }}
                </div>
                <div class="cars-brand">
                  {{ reservation.vehicle.factoryName }}
                  {{ reservation.vehicle.brandName }}
                  {{
                    reservation.vehicle.plateNumber
                      ? `(${reservation.vehicle.plateNumber})`
                      : ""
                  }}
                  <span class="cars-brand-equivalent">or equivalent</span>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="capacity-seat" v-if="hasPaxCapacity">
                      Pax Capacity {{ reservation.vehicle.feature.paxCapacity }}
                    </div>
                    <div
                      class="capacity-large-baggage"
                      v-if="hasLargeBaggageCapacity"
                    >
                      Large Bag. Capacity x{{
                        reservation.vehicle.feature.largeBaggageCapacity
                      }}
                    </div>
                    <div
                      class="capacity-baggage"
                      v-if="hasSmallBaggageCapacity"
                    >
                      Small Bag. Capacity x{{
                        reservation.vehicle.feature.smallBaggageCapacity
                      }}
                    </div>
                    <!-- <div
                      class="transmission-automatic"
                      v-if="isAutomaticTransmission"
                    >
                      Automatic Transmission
                    </div>
                    <div
                      class="transmission-manual"
                      v-else-if="!isAutomaticTransmission"
                    >
                      Manual Transmission
                    </div> -->
                  </div>

                  <div
                    class="col-sm-12 text-center"
                    style="padding: 20px 0"
                    v-if="reservation.rateTaggings.length > 0"
                  >
                    <div class="row-badge">
                      <span
                        class="badge badge-tag"
                        v-for="tag in reservation.rateTaggings"
                        :key="tag.id"
                        :style="`color: ${tag.textColor}; background: ${tag.backgroundColor}`"
                        >{{ tag.text }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="cRow" v-if="reservation.vehicle">
                <div class="col-sm-12">
                  <img
                    :src="
                      reservation.vehicle.imageUri
                        ? reservation.vehicle.imageUri
                        : cdn + '/images/vehicle-dummy.png'
                    "
                    alt
                    class="cars-image"
                  />
                </div>
              </div>
              <div
                class="provider-box cRowen-col no-border"
                v-if="reservation.provider"
              >
                <div class="provider-name">{{ reservation.provider.name }}</div>
                <div class="provider-name">
                  (+{{ reservation.provider.phoneCode }})
                  {{ reservation.provider.phoneNumber }}
                </div>
                <div class="provider-img cRow">
                  <img :src="reservation.provider.imageUri" alt />
                </div>
                <!-- <button
                  data-toggle="modal"
                  data-target="#terms-modal"
                  class="btn btn-info"
                >
                  Terms
                </button> -->
              </div>
            </div>
            <div class="reservation-summary--small" v-if="reservation.feedback">
              <div class="cars-brand">Customer's Feedback</div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group mt-10">
                    <p>{{ reservation.feedback.comment }}</p>
                  </div>
                  <div class="form-group">
                    <label>Rating</label>
                    <vue-stars
                      v-model="reservation.feedback.score"
                      v-bind:readonly="true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header" style="padding-bottom: 10px">
          <div class="pull-right">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <i class="ic-close"></i>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <mapModal />
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="previewimage">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4 class="modal-title">SUPPORTING DOCUMENTS</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12 mt-10">
                <div class="wrapper-pax-no-show">
                  <h4 class="title-category">
                    1. Attempts to Contact Passenger
                  </h4>
                  <div class="preview-image" v-if="previewImagePax">
                    <img
                      :src="previewImagePax.path"
                      alt="Trransfer-Preview-Image"
                    />
                    <div class="black-wrapper">
                      <div class="address-wrapper">
                        <span class="driver-label"
                          >{{
                            previewImagePax && previewImagePax.driverName
                          }}
                          ({{
                            previewImagePax && previewImagePax.vehiclePlateNo
                          }})
                        </span>
                        <span class="time-label"
                          >{{
                            previewImagePax &&
                            previewImagePax.timeStamp.dateTime | momentTime
                          }}
                          ({{
                            previewImagePax &&
                            previewImagePax.timeStamp.timezone
                          }})
                        </span>
                        <span class="address-label"
                          >{{ previewImagePax && previewImagePax.locationName }}
                        </span>
                        <span class="address-label"
                          >{{
                            previewImagePax && previewImagePax.locationAddress
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="images-list">
                    <template v-for="(img, id) in imgCategoryPax">
                      <img
                        :src="img.path"
                        :class="
                          img.id === previewImagePax.id
                            ? 'image-item active'
                            : 'image-item'
                        "
                        draggable="false"
                        loading="lazy"
                        :key="id"
                        @click="setPreviewImage(img, 1)"
                      />
                    </template>
                  </div>
                </div>
                <div class="wrapper-pax-no-show">
                  <h4 class="title-category">
                    2. Vehicle on Location with Time Stamp (e.g. photo of
                    vehicle on site, map location screenshot)
                  </h4>
                  <div class="preview-image" v-if="previewVehicle">
                    <img
                      :src="previewVehicle.path"
                      alt="Trransfer-Preview-Image"
                    />
                    <div class="black-wrapper">
                      <div class="address-wrapper">
                        <span class="driver-label"
                          >{{ previewVehicle && previewVehicle.driverName }} ({{
                            previewVehicle && previewVehicle.vehiclePlateNo
                          }})
                        </span>
                        <span class="time-label"
                          >{{
                            previewVehicle &&
                            previewVehicle.timeStamp.dateTime | momentTime
                          }}
                          ({{
                            previewVehicle && previewVehicle.timeStamp.timezone
                          }})
                        </span>
                        <span class="address-label"
                          >{{ previewVehicle && previewVehicle.locationName }}
                        </span>
                        <span class="address-label"
                          >{{
                            previewVehicle && previewVehicle.locationAddress
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="images-list">
                    <template v-for="(img, id) in imgCategoryVehicle">
                      <img
                        :src="img.path"
                        class="image-item"
                        :class="
                          img.id === previewVehicle.id
                            ? 'image-item active'
                            : 'image-item'
                        "
                        draggable="false"
                        loading="lazy"
                        :alt="`Trransfer-Image${id}`"
                        :key="id"
                        @click="setPreviewImage(img, 2)"
                      />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="previewimageormaps">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex" style="justify-content: flex-end">
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12 mt-10">
                <div class="maps-image-wrapper">
                  <img
                    :src="showPreviewImg.path"
                    v-if="showPreviewImg"
                    alt="preview-image"
                    :class="showPreviewImg.rotate"
                  />
                  <div class="black-wrapper">
                    <div class="address-wrapper">
                      <span class="driver-label"
                        >{{ showPreviewImg && showPreviewImg.driverName }} ({{
                          showPreviewImg && showPreviewImg.vehiclePlateNo
                        }})
                      </span>
                      <span class="time-label"
                        >{{
                          showPreviewImg &&
                          showPreviewImg.timeStamp.dateTime | momentTime
                        }}
                        ({{
                          showPreviewImg && showPreviewImg.timeStamp.timezone
                        }})
                      </span>
                      <span class="address-label"
                        >{{ showPreviewImg && showPreviewImg.locationName }}
                      </span>
                      <span class="address-label"
                        >{{ showPreviewImg && showPreviewImg.locationAddress }}
                      </span>
                    </div>
                  </div>
                  <button
                    class="btn-rotate"
                    id="btn-rotate"
                    @click="handleRotateImage(showPreviewImg)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M3.86 18.46c2.65 3.45 7.11 4.37 10.74 2.79c.61-.27.74-1.09.27-1.56l-.05-.05c-.29-.29-.72-.35-1.1-.19c-2.96 1.24-6.59.37-8.58-2.62c-1.58-2.37-1.55-5.37.05-7.73C6.6 7.03 8.8 6.03 11 6.03v1.76c0 .45.54.67.86.36l2.79-2.79c.2-.2.2-.51 0-.71l-2.8-2.79a.495.495 0 0 0-.85.35v1.8c-2.76 0-5.52 1.25-7.34 3.78c-2.28 3.17-2.2 7.58.2 10.67z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M17.7 7.71a.996.996 0 0 0-1.41 0l-4.59 4.58a.996.996 0 0 0 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59a.996.996 0 0 0 0-1.41L17.7 7.71z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </button>
                  <div
                    id="map-container"
                    :class="{
                      'none-display': showPreviewImg,
                      display: !showPreviewImg,
                    }"
                  ></div>
                </div>
              </div>
              <div class="col-sm-12 mt-10">
                <div class="maps-image-list-wrapper">
                  <div
                    class="maps-image-list"
                    v-for="(item, idx) in showListPreview"
                    :key="idx"
                  >
                    <img
                      :src="item.path"
                      :alt="item.path"
                      class="maps-image"
                      @click="setPreviewMapsOrImage('img', item)"
                    />
                    <button
                      class="btn-view"
                      @click="setPreviewMapsOrImage('maps', item)"
                    >
                      View Map
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <deleteModal @submit="deleteSignage" @cancel="cancelDeleteSignage" />

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import mapModal from "@/components/shared/MapModal";
import deleteModal from "@/components/shared/DeleteModal";
import PdfViewer from "@/components/shared/PdfViewer";
import tripLogJobService from "@/services/job/tripLogJob/tripLogJobService.js";
import inquiryProviderJobService from "@/services/job/providerJob/inquiryProviderJobService.js";
import inquiryReservationService from "@/services/shop/reservation/inquiryReservationService.js";
import inquiryTenantJobService from "@/services/job/tenantJob/inquiryTenantJobService.js";
import maverickDirection from "@/plugins/google/direction.js";
import maverickMap from "@/plugins/google/map.js";
import geocodeService from "@/services/util/geocodeService.js";
import {
  allowToViewAdminNotes,
  allowToViewCustomerNotes,
} from "@/helpers/userHelper.js";
import html2pdf from "html2pdf.js";

export default {
  components: { mapModal, deleteModal, PdfViewer },
  computed: {
    isPDFFile() {
      return (
        this.reservation.signage &&
        this.reservation.signage.fileUrl.toLowerCase().endsWith(".pdf")
      );
    },
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
    isAllowViewAdminNotes: function () {
      return allowToViewAdminNotes(this.allServices);
    },
    isAllowViewCustomerNotes: function () {
      return allowToViewCustomerNotes(this.allServices);
    },
    progressClassName: function () {
      if (this.reservation) {
        switch (this.reservation.progress.toLowerCase()) {
          case "open":
            return "sts_job-open";
          case "run":
            return "sts_job-run";
          case "done":
            return "sts_job-done";
          case "close":
            return "sts_job-closed";
          case "abort":
            return "sts_job-aborted";
          case "rescueoperation":
            return "rescue_operation";
        }
      }
      return "";
    },
    isAutomaticTransmission: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.transmission.toLowerCase() === "at"
      );
    },
    hasPaxCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.paxCapacity &&
        parseInt(this.reservation.vehicle.feature.paxCapacity) > 0
      );
    },
    hasLargeBaggageCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.largeBaggageCapacity &&
        parseInt(this.reservation.vehicle.feature.largeBaggageCapacity) > 0
      );
    },
    hasSmallBaggageCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.smallBaggageCapacity &&
        parseInt(this.reservation.vehicle.feature.smallBaggageCapacity) > 0
      );
    },
    isAirportTransfer: function () {
      return (
        this.reservation &&
        this.reservation.serviceType !== "" &&
        this.reservation.serviceType.toLowerCase() === "airporttransfer"
      );
    },
    isArrivedFlight: function () {
      return (
        this.reservation &&
        this.reservation.pickUpLocation &&
        this.reservation.pickUpLocation.isAirport
      );
    },
    isDepartureFlight: function () {
      return (
        this.reservation &&
        this.reservation.dropOffLocation &&
        this.reservation.dropOffLocation.isAirport
      );
    },
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
  },
  data() {
    return {
      allPermissions: [],
      ancillaries: [],
      surcharges: [],
      moneyFormat: null,
      direction: null,
      map: null,
      reservation: {},
      isDifferentCurrency: false,
      totalExtraService: 0,
      totalEquivalentExtraService: 0,
      postBooking: [],
      isHaveExtra: false,
      isLoading: false,
      msg: "Please wait",
      userType: "Unspecified",
      sameBookerAndPassenger: false,
      allServices: null,
      imgCategoryPax: [],
      previewImagePax: null,
      imgCategoryVehicle: [],
      previewVehicle: null,
      showListPreview: [],
      showPreviewImg: null,
      collapseHistory: false,
    };
  },
  async created() {
    await this.getById(this.$route.params.id);
    await this.getUserType();
    const { services } = await this.$store.dispatch("user/getProfile");
    this.allServices = services;
  },
  mounted() {
    if (!this.direction) {
      // creates direction instance
      this.direction = new maverickDirection({
        mapId: "map",
      });
    }

    if (!this.map) {
      this.map = new maverickMap({
        mapId: "map-container",
        lat: -6.17003832454938,
        lng: 106.81490242481232,
        infoWindow: true,
      });
      this.map.initialize();
    }
  },
  methods: {
    handleCollapse() {
      this.collapseHistory = !this.collapseHistory;
    },
    openDeleteModal() {
      $("#deletemodal").modal();
    },
    cancelDeleteSignage() {
      $("#deletemodal").modal("hide");
    },
    async editSignage(file) {
      this.isLoading = true;
      const maxAllowedSize = 1 * 1024 * 1024;
      if (file[0].size > maxAllowedSize) {
        this.$notification.error("File signage must be less than 1MB", {
          title: "Error",
        });
        this.isLoading = false;
        return;
      }
      try {
        let formData = new FormData();
        formData.append("file", file[0]);
        await inquiryReservationService.updateSignage(
          this.$route.params.id,
          formData
        );
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.getById(this.$route.params.id);
      }
    },
    downloadSignage() {
      const fileUrl = this.reservation.signage
        ? this.reservation.signage.fileUrl
        : null;

      if (fileUrl) this.downloadSignageFromUrl();
      else this.downloadDefaultSignage();
    },
    downloadDefaultSignage() {
      const element = document.createElement("div");

      element.innerHTML = `
        <div style="
          width: 100%;
          height: 210mm;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 100px;
          font-weight: bold;
          font-family: Arial, sans-serif;
          box-sizing: border-box;
          word-break: break-word;
        ">
          <div>${this.reservation.customers[0].title}. ${this.reservation.customers[0].fullName}</div>
        </div>
      `;

      html2pdf()
        .set({
          margin: 0,
          filename: `${this.reservation.customers[0].fullName}.pdf`,
          image: {
            type: "jpeg",
            quality: 1,
          },
          html2canvas: {
            scale: 2,
          },
          jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "landscape",
          },
        })
        .from(element)
        .save();
    },
    async downloadSignageFromUrl() {
      const fileUrl = this.reservation.signage.fileUrl;
      const extension = fileUrl.split(".").pop();
      try {
        // Fetch the file
        const response = await fetch(fileUrl, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, HEAD",
            "Access-Control-Max-Age": 3000,
            "Content-Disposition": "attachment",
          },
        });
        const blob = await response.blob();

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element
        const link = document.createElement("a");
        link.href = url;
        link.download = `${this.reservation.customers[0].fullName}.${extension}`;
        link.click();

        // Release the object URL
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$notification.error(
          `Error downloading the file: ${error}. \n You can download the signage manually`,
          {
            title: "Error",
          }
        );
        let linkOpenNewTab = document.createElement("a");

        linkOpenNewTab.href = fileUrl;
        linkOpenNewTab.download = `${this.detail.passengers[0].fullName}.${extension}`;

        if (linkOpenNewTab) {
          linkOpenNewTab.target = "_blank";
          linkOpenNewTab.rel = "noopener noreferrer";
        }

        document.body.appendChild(linkOpenNewTab);
        linkOpenNewTab.click();
        document.body.removeChild(linkOpenNewTab);
      }
    },
    async deleteSignage() {
      this.isLoading = true;
      try {
        const response = await inquiryReservationService.deleteSignage(
          this.$route.params.id
        );

        if (response.isSuccess) {
          this.$notification.success("Signage deleted successfully", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.getById(this.$route.params.id);
      }
    },
    async getById(id) {
      try {
        this.isLoading = true;
        this.reservation = await inquiryProviderJobService.getDetail(id);
        this.moneyFormat = this.reservation.moneyFormat;

        const { booker, customers } = this.reservation;
        const bookerData = {
          title: booker.title,
          name: booker.fullName,
          email: booker.email,
          phonenumber: `${booker.phoneCode}${booker.phoneNumber}`,
        };
        const passengerData = {
          title: customers[0].title,
          name: customers[0].fullName,
          email: customers[0].email,
          phonenumber: `${customers[0].phoneCode}${customers[0].phoneNumber}`,
        };
        this.sameBookerAndPassenger = _.isEqual(bookerData, passengerData);

        if (
          this.reservation.fareComponents &&
          this.reservation.fareComponents.length > 0
        ) {
          this.ancillaries = this.reservation.fareComponents.filter(
            (x) =>
              x.category === "Buying" &&
              x.type === "Extra" &&
              x.isPreBooking === true
          );
          this.surcharges = this.reservation.fareComponents.filter(
            (x) => x.category === "Buying" && x.type === "Surcharge"
          );

          let existBuyingFare = this.reservation.fareComponents.filter(
            (x) => x.category === "Buying"
          );
          if (
            existBuyingFare[0].equivalentCurrencyCode != null &&
            existBuyingFare[0].equivalentCurrencyCode != "" &&
            existBuyingFare[0].equivalentCurrencyCode !=
              this.reservation.moneyFormat.currencyCode
          ) {
            this.moneyFormat.equivalentCurrencyCode =
              existBuyingFare[0].equivalentCurrencyCode;
            this.isDifferentCurrency = true;
          }
          this.postBooking = this.reservation.fareComponents.filter(
            (f) =>
              f.category === "Buying" &&
              f.type !== "Surcharge" &&
              !f.isPreBooking
          );
          this.totalExtraService = this.postBooking.reduce(
            (accum, item) => accum + item.rate,
            0
          );
          this.totalEquivalentExtraService = this.postBooking.reduce(
            (accum, item) => accum + item.equivalentRate,
            0
          );
          if (this.postBooking.length > 0) {
            this.isHaveExtra = true;
          }
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async openMapModal() {
      if (this.reservation.logLocations) {
        await this.direction.display(this.reservation.logLocations);
      }
      $(this.$refs.mapmodal).modal();
    },
    openPreviewImagePaxNoShow() {
      $(this.$refs.previewimage).modal();
    },
    async getUserType() {
      const profile = await this.$store.dispatch("user/getProfile");
      this.userType = profile.userType;
    },
    isButtonShowPaxNoShow(history) {
      if (history == null || history == undefined) {
        return false;
      }

      const historyIncludes = history.includes("link:");
      if (historyIncludes) {
        return true;
      } else {
        return false;
      }
    },
    isButtonShow(history) {
      if (history == null || history == undefined) {
        return false;
      }

      var historySplit = history.split(/:(.+)/);
      if (historySplit[0] === "link") {
        return true;
      } else {
        return false;
      }
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    getEventDescription(history) {
      return this.$helper.getEventDescription(history, this.userType);
    },
    showAmendLog(history) {
      const amendEvents = [
        "amendbooking",
        "amendbookingdetails",
        "amendbookingrequested",
      ];
      return (
        amendEvents.includes(history.event.toLowerCase()) && history.amendLog
      );
    },
    showPassengerDetailOnHistory(amendLog) {
      const isEqual = _.isEqual(
        amendLog.passenger.new,
        amendLog.passenger.previous
      );

      if (!isEqual) return true;
      return false;
    },
    showBookerOnHistory(amendLog) {
      const isEqual = _.isEqual(amendLog.booker.new, amendLog.booker.previous);

      if (!isEqual) return true;
      return false;
    },
    showScheduleOnHistory(amendLog) {
      const isEqual = _.isEqual(
        amendLog.schedules.new,
        amendLog.schedules.previous
      );

      if (!isEqual) return true;
      return false;
    },
    showDestinationOnHistory(amendLog) {
      const isEqual = _.isEqual(
        amendLog.locations.new,
        amendLog.locations.previous
      );

      if (!isEqual) return true;
      return false;
    },
    async getImage(item) {
      try {
        this.isLoading = true;
        const response = await inquiryTenantJobService.viewHistoryEvidence(
          item.id
        );
        window.open(response.data, "_blank");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getAttachmentImage(history) {
      this.isLoading = true;
      try {
        let imgCategoryVehicle = [];
        let imgCategoryPax = [];
        let showListPreview = [];

        for (let i = 0; i < history.attachments.length; i++) {
          const response = await tripLogJobService.getAttachment(
            this.$route.params.id,
            history.attachments[i].path
          );

          if (response.isSuccess) {
            if (history.event === "PassengerNoShowOrCancelled") {
              if (history.attachments[i].category === 1) {
                this.previewImagePax = {
                  ...history.attachments[i],
                  id: imgCategoryPax.length,
                  path: response.data,
                };
                imgCategoryPax.push({
                  ...history.attachments[i],
                  id: imgCategoryPax.length,
                  path: response.data,
                });
              } else {
                this.previewVehicle = {
                  ...history.attachments[i],
                  id: imgCategoryVehicle.length,
                  path: response.data,
                };
                imgCategoryVehicle.push({
                  ...history.attachments[i],
                  id: imgCategoryVehicle.length,
                  path: response.data,
                });
              }
            } else {
              showListPreview.push({
                ...history.attachments[i],
                path: response.data,
                rotate: "default",
              });
            }
          }
        }

        this.imgCategoryPax = imgCategoryPax;
        this.imgCategoryVehicle = imgCategoryVehicle;
        this.showListPreview = showListPreview;
        this.showPreviewImg = showListPreview.length
          ? showListPreview[0]
          : null;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;

        if (history.event === "PassengerNoShowOrCancelled") {
          this.openPreviewImagePaxNoShow();
        } else {
          this.openPreviewImageOrMaps();
        }
      }
    },
    handleRotateImage(data) {
      if (data.rotate === "default") {
        data.rotate = "right";
      } else if (data.rotate === "right") {
        data.rotate = "bottom";
      } else if (data.rotate === "bottom") {
        data.rotate = "left";
      } else {
        data.rotate = "default";
      }
    },
    setPreviewImage(data, type) {
      if (type === 1) {
        this.previewImagePax = data;
      } else {
        this.previewVehicle = data;
      }
    },
    async setPreviewMapsOrImage(type, data) {
      this.showPreviewImg = null;
      if (type === "img") {
        this.showPreviewImg = data;
      } else {
        const response = await geocodeService.reverse({
          lat: data.latitude,
          lng: data.longitude,
        });

        this.map.showInfoWindow(
          {
            latitude: data.latitude,
            longitude: data.longitude,
          },
          response.data
        );
      }
    },
    openPreviewImageOrMaps() {
      $(this.$refs.previewimageormaps).modal();
    },
  },
  filters: {
    momentTime: function (time) {
      return moment(time).parseZone().format("D MMM YYYY HH:mm");
    },
  },
};
</script>

<style scoped>
.gmap-point-container {
  height: 580px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/job/providerJob/ProviderJobDetail.vue